@let stationInfoValue = stationInfo();
@let smwDataValue = smwData();
@let langSignalValue = languageService.langSignal();

<mat-card appearance="outlined" class="smw-archive-card">
  <!-- 1. DYNAMISCHE STRUKTURIERTE HEADLINE -->
  @if (startIsValid() && endIsValid()) {
    <mat-card-title class="archive-card-title active-range-title">
      <fa-icon
        [icon]="['far', 'calendar-check']"
        class="title-status-icon"></fa-icon>
      &nbsp;
      {{ 'PRODUCT.SMW.ARCHIVE.SELECTED_TIME_RANGE' | translate }}:
      <span class="range-date-highlight">
        {{
          startValueSig() | datex: 'DD.MM.YYYY' : undefined : langSignalValue
        }}
        -
        {{ endValueSig() | datex: 'DD.MM.YYYY' : undefined : langSignalValue }}
      </span>
    </mat-card-title>
  } @else {
    <mat-card-title class="archive-card-title empty-range-title">
      <fa-icon
        [icon]="['far', 'calendar-alt']"
        class="title-status-icon"></fa-icon>
      &nbsp;
      {{ 'PRODUCT.SMW.ARCHIVE.CLICK_START_END_DATE' | translate }}
    </mat-card-title>
  }

  <!-- 2. STEUERUNGS-PANEL (Flex-Row-Verbund) -->
  <div class="archive-controls-panel">
    <!-- Zeitraums-Eingabe (MDC Date Range Input) -->
    <mat-form-field
      appearance="fill"
      class="archive-range-field"
      subscriptSizing="dynamic">
      <mat-label>{{
        'PRODUCT.SMW.ARCHIVE.SELECT_TIME_RANGE' | translate
      }}</mat-label>
      <mat-date-range-input
        [formGroup]="range"
        [rangePicker]="picker"
        [dateFilter]="dateFilter"
        class="archive-range-inputs">
        <input
          matStartDate
          formControlName="start"
          placeholder="Startdatum"
          class="archive-input-element" />
        <input
          matEndDate
          formControlName="end"
          placeholder="Enddatum"
          class="archive-input-element" />
      </mat-date-range-input>

      <mat-datepicker-toggle matIconSuffix [for]="picker">
        <fa-icon
          matDatepickerToggleIcon
          [icon]="['far', 'calendar-alt']"
          transform="up-1 shrink-2"
          size="lg"></fa-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Validierungsfehler (Werden dank dynamic sizing sauber eingereiht) -->
    <div class="archive-validation-errors">
      @if (startHasMatError()) {
        <mat-error>Invalid start date</mat-error>
      } @else if (endHasMatError()) {
        <mat-error>Invalid end date</mat-error>
      }
      @if (startHasMatRequiredError()) {
        <mat-error>Start date is required</mat-error>
      } @else if (endHasMatRequiredError()) {
        <mat-error>End date is required</mat-error>
      }
    </div>

    <!-- Aktions-Schaltflächen -->
    <div class="archive-actions-group">
      <button
        mat-flat-button
        color="primary"
        class="btn-archive-query"
        (click)="onQueryData()"
        [disabled]="rangeInvalid()">
        <fa-icon [icon]="['far', 'th']"></fa-icon> &nbsp;
        {{ 'PRODUCT.SMW.ARCHIVE.QUERY_DATA' | translate }}
      </button>

      <a
        csvLink
        mat-flat-button
        class="btn-archive-download"
        [data]="csvData"
        [headers]="csvHeader"
        [delimiter]="';'"
        [filename]="csvFileName"
        (click)="onCreateCSV()"
        [disabled]="!smwDataValue">
        <fa-icon [icon]="['far', 'download']"></fa-icon> &nbsp;
        {{ 'PRODUCT.SMW.ARCHIVE.DOWNLOAD_DATA' | translate }}
      </a>
    </div>

    <!-- Drittanbieter Quellen-Hinweis (DWD-Logo) -->
    @if (stationInfoValue.type < '3') {
      <div class="source-info">
        <span class="source-label">Quelle:</span>
        <img
          class="source-image dwd-logo-themed"
          src="/assets/images/DWD-Logo.svg"
          alt="DWD Logo" />
      </div>
    }
  </div>
</mat-card>

<!-- 3. DATEN-TABELLE -->
@if (smwDataValue) {
  <div class="archive-table-wrapper">
    <app-smw-table
      [smwData]="smwDataValue"
      [station]="stationId()"
      [webcamStatus]="false"
      [stationInfo]="stationInfoValue">
    </app-smw-table>
  </div>
}
